import { Component, ViewEncapsulation, ElementRef, inject, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IOverlayAngularComp } from 'ag-grid-angular';
import { IOverlayParams } from 'ag-grid-community';

@Component({
    selector: 'lib-grid-loading-overlay',
    imports: [MatProgressSpinnerModule],
    templateUrl: './grid-loading-overlay.component.html',
    styleUrls: ['./grid-loading-overlay.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class GridLoadingOverlayComponent implements IOverlayAngularComp {
    loadingText = input('');
    private readonly elementRef = inject(ElementRef);

    agInit(params: IOverlayParams): void {
        // No specific initialization needed for loading overlay
    }

    getGui(): HTMLElement {
        return this.elementRef.nativeElement;
    }
}
